// @ts-nocheck
import { Modal } from 'db-npm-e4sc-rd-ui';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorMessage } from '../../shared/components/ErrorMessage/ErrorMessage';
import { ThankYouMessage } from '../../shared/components/ThankYouMessage/ThankYouMessage';
import { submitFormData } from '../../shared/forms/submitFormData';
import { LaunchData, useAdobeTracking } from '../../shared/hooks';
import GDPRForm from './GDPRForm';

export type FormGDPRProps = {
  fields: any;
};

const FormGdpr: React.FC<FormGDPRProps> = ({ fields = {} }) => {
  const { t } = useTranslation();
  const [page, setPage] = useState(0);
  const [showModal, setShowModal] = React.useState(false);
  const toggleModal = () => setShowModal(!showModal);

  const launchData: LaunchData = {
    form_product: 'GDRP request',
    form_type: 'GDPR information request',
    form_name: 'GDPR form',
    form_step: 'Initial step',
    form_status: ['loaded', 'view step'],
  };

  const { trackFormSubmitSuccess, trackFormSubmitFail } = useAdobeTracking(launchData);

  const goToNextPage = () => {
    setPage(page + 1);
    window.scrollTo(0, 0);
  };

  const onSubmitData = async (formData) => {
    const response = await submitFormData(
      {
        apiUrl: fields['API Endpoint URL']?.value,
        apiKey: fields['API Key']?.value,
        egainDsid: fields['Egain DSID']?.value,
      },
      formData
    );
    if (response) {
      goToNextPage();
      trackFormSubmitSuccess();
    } else {
      trackFormSubmitFail();

      //Error Handling
      setShowModal(true);
    }
  };

  /* conditional rendering  */
  switch (page) {
    case 0:
      return (
        <>
          <GDPRForm fields={fields} onSubmitData={onSubmitData} />
          <Modal open={showModal} handleClose={toggleModal} ariaCloseLabel={'Close modal'} overlayColor="#1f2532">
            <ErrorMessage message={t('form-submit-error')} />
          </Modal>
        </>
      );
    case 1: //Thank You Message
      return <ThankYouMessage fields={fields} />;
  }

  return null;
};

export default FormGdpr;
